import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b85e94f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "accordion accordion-unbordered accordion-multiselectable" }
const _hoisted_2 = { class: "mb-5 product-box" }
const _hoisted_3 = ["aria-controls", "aria-expanded", "id"]
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-6 align-self-center" }
const _hoisted_6 = { class: "col-6 accordion-label" }
const _hoisted_7 = {
  key: 0,
  class: "badge-custom badge badge-small accordion-label ml-3"
}
const _hoisted_8 = {
  key: 1,
  class: "badge-custom badge badge-small accordion-label ml-3"
}
const _hoisted_9 = {
  key: 2,
  class: "badge-custom badge badge-small accordion-label ml-3"
}
const _hoisted_10 = {
  key: 3,
  class: "badge-custom badge badge-small accordion-label"
}
const _hoisted_11 = {
  key: 4,
  class: "badge-custom badge badge-small accordion-label"
}
const _hoisted_12 = {
  key: 5,
  class: "badge-custom badge badge-small accordion-label"
}
const _hoisted_13 = ["id", "aria-hidden"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "mb-6" }, null, -1))
const _hoisted_15 = ["id"]
const _hoisted_16 = {
  key: 0,
  class: "col-4 actions"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_18 = ["id"]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "icon-svg",
  focusable: "false",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#mode" })
], -1))
const _hoisted_21 = ["onClick", "id"]
const _hoisted_22 = {
  href: "javascript:void(0);",
  class: "function-link"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "icon-svg",
  focusable: "false",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#delete" })
], -1))
const _hoisted_24 = { class: "mb-4" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spinner" }, null, -1))
const _hoisted_27 = { class: "spinner-status" }
const _hoisted_28 = { class: "table table--borderless table--compact table--responsive-headers d-print-table" }
const _hoisted_29 = ["id"]
const _hoisted_30 = { class: "w-percent-md-40 align-text-right result-value" }
const _hoisted_31 = ["id"]
const _hoisted_32 = { class: "w-percent-md-10" }
const _hoisted_33 = ["data-tooltip"]
const _hoisted_34 = {
  key: 0,
  class: "icon-svg",
  focusable: "false",
  "aria-hidden": "true"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#help-circle-outline" }, null, -1))
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = { class: "sr-only" }
const _hoisted_38 = ["id"]
const _hoisted_39 = { class: "w-percent-md-40 align-text-right result-value" }
const _hoisted_40 = ["id"]
const _hoisted_41 = { class: "w-percent-md-10" }
const _hoisted_42 = ["data-tooltip"]
const _hoisted_43 = {
  key: 0,
  class: "icon-svg",
  focusable: "false",
  "aria-hidden": "true"
}
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#help-circle-outline" }, null, -1))
const _hoisted_45 = [
  _hoisted_44
]
const _hoisted_46 = { class: "sr-only" }
const _hoisted_47 = ["id"]
const _hoisted_48 = { class: "w-percent-md-40 align-text-right result-value" }
const _hoisted_49 = ["id"]
const _hoisted_50 = { class: "w-percent-md-10" }
const _hoisted_51 = ["data-tooltip"]
const _hoisted_52 = {
  key: 0,
  class: "icon-svg",
  focusable: "false",
  "aria-hidden": "true"
}
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#help-circle-outline" }, null, -1))
const _hoisted_54 = [
  _hoisted_53
]
const _hoisted_55 = { class: "sr-only" }
const _hoisted_56 = ["id"]
const _hoisted_57 = { class: "w-percent-md-40 align-text-right result-value" }
const _hoisted_58 = ["id"]
const _hoisted_59 = { class: "w-percent-md-10" }
const _hoisted_60 = ["data-tooltip"]
const _hoisted_61 = {
  key: 0,
  class: "icon-svg",
  focusable: "false",
  "aria-hidden": "true"
}
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#help-circle-outline" }, null, -1))
const _hoisted_63 = [
  _hoisted_62
]
const _hoisted_64 = { class: "sr-only" }
const _hoisted_65 = ["id"]
const _hoisted_66 = { class: "w-percent-md-40 align-text-right result-value" }
const _hoisted_67 = ["id"]
const _hoisted_68 = { class: "w-percent-md-10" }
const _hoisted_69 = ["data-tooltip"]
const _hoisted_70 = {
  key: 0,
  class: "icon-svg",
  focusable: "false",
  "aria-hidden": "true"
}
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#help-circle-outline" }, null, -1))
const _hoisted_72 = [
  _hoisted_71
]
const _hoisted_73 = { class: "sr-only" }
const _hoisted_74 = ["id"]
const _hoisted_75 = { class: "w-percent-md-40 align-text-right result-value" }
const _hoisted_76 = ["id"]
const _hoisted_77 = { class: "w-percent-md-10" }
const _hoisted_78 = ["data-tooltip"]
const _hoisted_79 = {
  key: 0,
  class: "icon-svg",
  focusable: "false",
  "aria-hidden": "true"
}
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#help-circle-outline" }, null, -1))
const _hoisted_81 = [
  _hoisted_80
]
const _hoisted_82 = { class: "sr-only" }
const _hoisted_83 = { class: "highlighted-co2" }
const _hoisted_84 = ["id"]
const _hoisted_85 = { class: "w-percent-md-40 align-text-right result-value" }
const _hoisted_86 = ["id"]
const _hoisted_87 = { class: "w-percent-md-10" }
const _hoisted_88 = ["data-tooltip"]
const _hoisted_89 = {
  key: 0,
  class: "icon-svg",
  focusable: "false",
  "aria-hidden": "true"
}
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#help-circle-outline" }, null, -1))
const _hoisted_91 = [
  _hoisted_90
]
const _hoisted_92 = { class: "sr-only" }
const _hoisted_93 = { class: "highlighted" }
const _hoisted_94 = ["id"]
const _hoisted_95 = { class: "w-percent-md-40 align-text-right result-value" }
const _hoisted_96 = ["id"]
const _hoisted_97 = { class: "w-percent-md-10" }
const _hoisted_98 = ["data-tooltip"]
const _hoisted_99 = {
  key: 0,
  class: "icon-svg",
  focusable: "false",
  "aria-hidden": "true"
}
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#help-circle-outline" }, null, -1))
const _hoisted_101 = [
  _hoisted_100
]
const _hoisted_102 = { class: "sr-only" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KlarTekst = _resolveComponent("KlarTekst")!
  const _component_CO2ComparisonChart = _resolveComponent("CO2ComparisonChart")!
  const _component_TCOScoreProductComparisonChart = _resolveComponent("TCOScoreProductComparisonChart")!

  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.formular.products, (p, index) => {
      return (_openBlock(), _createElementBlock("li", {
        key: p,
        class: _normalizeClass({ 'force-page-break': index !== (this.formular.products.length - 1) })
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", {
            "aria-controls": 'product-'+index,
            "aria-expanded": this.printMode || this.formular.products.length === 1,
            class: "accordion-button product-accordion",
            id: 'product-button-'+index
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("h3", null, _toDisplayString(p.formular.trin[1].felter[0].vaerdi ? p.formular.trin[1].felter[0].vaerdi : 'Produkt #' + (index + 1)), 1)
              ]),
              _createElementVNode("div", _hoisted_6, [
                (index === 0)
                  ? (_openBlock(), _createElementBlock("label", _hoisted_7, [
                      _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.tg-blanket.resultat.laveste-totalomkostninger' }, null, 8, ["tekstNoegle"])
                    ]))
                  : _createCommentVNode("", true),
                (index === 1)
                  ? (_openBlock(), _createElementBlock("label", _hoisted_8, [
                      _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.tg-blanket.resultat.2-laveste-totalomkostninger' }, null, 8, ["tekstNoegle"])
                    ]))
                  : _createCommentVNode("", true),
                (index === 2)
                  ? (_openBlock(), _createElementBlock("label", _hoisted_9, [
                      _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.tg-blanket.resultat.3-laveste-totalomkostninger' }, null, 8, ["tekstNoegle"])
                    ]))
                  : _createCommentVNode("", true),
                (this.initialized && this.getCo2OrderForProductIndex(index) === 0)
                  ? (_openBlock(), _createElementBlock("label", _hoisted_10, [
                      _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.tg-blanket.resultat.laveste-co2-aftryk' }, null, 8, ["tekstNoegle"])
                    ]))
                  : _createCommentVNode("", true),
                (this.initialized && this.getCo2OrderForProductIndex(index) === 1)
                  ? (_openBlock(), _createElementBlock("label", _hoisted_11, [
                      _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.tg-blanket.resultat.2-laveste-co2-aftryk' }, null, 8, ["tekstNoegle"])
                    ]))
                  : _createCommentVNode("", true),
                (this.initialized && this.getCo2OrderForProductIndex(index) === 2)
                  ? (_openBlock(), _createElementBlock("label", _hoisted_12, [
                      _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.tg-blanket.resultat.3-laveste-co2-aftryk' }, null, 8, ["tekstNoegle"])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ], 8, _hoisted_3),
          _createElementVNode("div", {
            id: 'product-'+index,
            "aria-hidden": !this.printMode || this.formular.products.length !== 1,
            class: "accordion-content product-accordion"
          }, [
            _hoisted_14,
            _createElementVNode("div", {
              class: "row",
              id: 'row-'+index
            }, [
              (!this.printMode)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createElementVNode("h5", null, [
                      _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.tg-blanket.resultat.handlinger' }, null, 8, ["tekstNoegle"])
                    ]),
                    _hoisted_17,
                    (!_ctx.standalone)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "action-div",
                          id: 'edit-product-' + index
                        }, [
                          _createElementVNode("a", {
                            onClick: ($event: any) => (_ctx.rediger(index)),
                            href: "javascript:void(0);",
                            class: "function-link"
                          }, [
                            _hoisted_20,
                            _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.tg-blanket.resultat.handlinger.rediger' }, null, 8, ["tekstNoegle"])
                          ], 8, _hoisted_19)
                        ], 8, _hoisted_18))
                      : _createCommentVNode("", true),
                    (this.formular.products.length > 1 && !_ctx.standalone)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          onClick: ($event: any) => (_ctx.deleteProduct(index)),
                          class: "action-div",
                          id: 'delete-product-' + index
                        }, [
                          _createElementVNode("a", _hoisted_22, [
                            _hoisted_23,
                            _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.tg-blanket.resultat.handlinger.fjern-produkt' }, null, 8, ["tekstNoegle"])
                          ])
                        ], 8, _hoisted_21))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: _normalizeClass((this.printMode ? 'col-11 summary-margins' : 'col-7') + ' summary-details')
              }, [
                _createElementVNode("h5", _hoisted_24, [
                  _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.tg-blanket.resultat.overskrift' }, null, 8, ["tekstNoegle"])
                ]),
                (!this.initialized)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      _hoisted_26,
                      _createElementVNode("div", _hoisted_27, [
                        _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.tg-blanket.resultat.spinner-tekst' }, null, 8, ["tekstNoegle"])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: "result-rows",
                  style: _normalizeStyle(_ctx.cssVars)
                }, [
                  _createElementVNode("table", _hoisted_28, [
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", {
                          class: "w-percent-md-50 not-bold result-label",
                          id: 'tco_label_tcoTotalsInitialAmount' + index
                        }, [
                          _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.resultat.label.resultat0" })
                        ], 8, _hoisted_29),
                        _createElementVNode("td", _hoisted_30, [
                          (this.initialized)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                id: 'tcoTotalsInitialAmount' + index
                              }, _toDisplayString(this.formatNumeric(p.score.tcoTotalsInitialAmount, this.currencyUnit)), 9, _hoisted_31))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", _hoisted_32, [
                          _createElementVNode("button", {
                            class: "js-tooltip button-unstyled info-button",
                            "data-tooltip": _ctx.contentfulTcoModel.findKlarTekst('tco.tg-resultat.tooltip0'),
                            "data-tooltip-trigger": "click"
                          }, [
                            (_ctx.contentfulTcoModel.findKlarTekst('tco.tg-resultat.tooltip0') !== 'tco.tg-resultat.tooltip0')
                              ? (_openBlock(), _createElementBlock("svg", _hoisted_34, _hoisted_36))
                              : _createCommentVNode("", true),
                            _createElementVNode("span", _hoisted_37, [
                              _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.tg-resultat.tooltip0" })
                            ])
                          ], 8, _hoisted_33)
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", {
                          class: "w-percent-md-50 not-bold result-label",
                          id: 'tco_label_tcoTotalsOperationalAmount' + index
                        }, [
                          _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.resultat.label.resultat1" })
                        ], 8, _hoisted_38),
                        _createElementVNode("td", _hoisted_39, [
                          (this.initialized)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                id: 'tcoTotalsOperationalAmount' + index
                              }, _toDisplayString(this.formatNumeric(p.score.tcoTotalsOperationalAmount, this.currencyUnit)), 9, _hoisted_40))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", _hoisted_41, [
                          _createElementVNode("button", {
                            class: "js-tooltip button-unstyled info-button",
                            "data-tooltip": _ctx.contentfulTcoModel.findKlarTekst('tco.tg-resultat.tooltip1'),
                            "data-tooltip-trigger": "click"
                          }, [
                            (_ctx.contentfulTcoModel.findKlarTekst('tco.tg-resultat.tooltip1') !== 'tco.tg-resultat.tooltip1')
                              ? (_openBlock(), _createElementBlock("svg", _hoisted_43, _hoisted_45))
                              : _createCommentVNode("", true),
                            _createElementVNode("span", _hoisted_46, [
                              _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.tg-resultat.tooltip1" })
                            ])
                          ], 8, _hoisted_42)
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", {
                          class: "w-percent-md-50 not-bold result-label",
                          id: 'tco_label_tcoTotalsServiceAmount' + index
                        }, [
                          _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.resultat.label.resultat2" })
                        ], 8, _hoisted_47),
                        _createElementVNode("td", _hoisted_48, [
                          (this.initialized)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                id: 'tcoTotalsServiceAmount' + index
                              }, _toDisplayString(this.formatNumeric(p.score.tcoTotalsServiceAmount, this.currencyUnit)), 9, _hoisted_49))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", _hoisted_50, [
                          _createElementVNode("button", {
                            class: "js-tooltip button-unstyled info-button",
                            "data-tooltip": _ctx.contentfulTcoModel.findKlarTekst('tco.tg-resultat.tooltip2'),
                            "data-tooltip-trigger": "click"
                          }, [
                            (_ctx.contentfulTcoModel.findKlarTekst('tco.tg-resultat.tooltip2') !== 'tco.tg-resultat.tooltip2')
                              ? (_openBlock(), _createElementBlock("svg", _hoisted_52, _hoisted_54))
                              : _createCommentVNode("", true),
                            _createElementVNode("span", _hoisted_55, [
                              _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.tg-resultat.tooltip2" })
                            ])
                          ], 8, _hoisted_51)
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", {
                          class: "w-percent-md-50 not-bold result-label",
                          id: 'tco_label_tcoTotalsExitAmount' + index
                        }, [
                          _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.resultat.label.resultat3" })
                        ], 8, _hoisted_56),
                        _createElementVNode("td", _hoisted_57, [
                          (this.initialized)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                id: 'tcoTotalsExitAmount' + index
                              }, _toDisplayString(this.formatNumeric(p.score.tcoTotalsExitAmount, this.currencyUnit)), 9, _hoisted_58))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", _hoisted_59, [
                          _createElementVNode("button", {
                            class: "js-tooltip button-unstyled info-button",
                            "data-tooltip": _ctx.contentfulTcoModel.findKlarTekst('tco.tg-resultat.tooltip3'),
                            "data-tooltip-trigger": "click"
                          }, [
                            (_ctx.contentfulTcoModel.findKlarTekst('tco.tg-resultat.tooltip3') !== 'tco.tg-resultat.tooltip3')
                              ? (_openBlock(), _createElementBlock("svg", _hoisted_61, _hoisted_63))
                              : _createCommentVNode("", true),
                            _createElementVNode("span", _hoisted_64, [
                              _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.tg-resultat.tooltip3" })
                            ])
                          ], 8, _hoisted_60)
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", {
                          class: "w-percent-md-50 not-bold result-label",
                          id: 'tco_label_tcoTotalsEnvironmentalAmount' + index
                        }, [
                          _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.resultat.label.resultat4" })
                        ], 8, _hoisted_65),
                        _createElementVNode("td", _hoisted_66, [
                          (this.initialized)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                id: 'tcoTotalsEnvironmentalAmount' + index
                              }, _toDisplayString(this.formatNumeric(p.score.tcoTotalsEnvironmentalAmount, this.currencyUnit)), 9, _hoisted_67))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", _hoisted_68, [
                          _createElementVNode("button", {
                            class: "js-tooltip button-unstyled info-button",
                            "data-tooltip": _ctx.contentfulTcoModel.findKlarTekst('tco.tg-resultat.tooltip4'),
                            "data-tooltip-trigger": "click"
                          }, [
                            (_ctx.contentfulTcoModel.findKlarTekst('tco.tg-resultat.tooltip4') !== 'tco.tg-resultat.tooltip4')
                              ? (_openBlock(), _createElementBlock("svg", _hoisted_70, _hoisted_72))
                              : _createCommentVNode("", true),
                            _createElementVNode("span", _hoisted_73, [
                              _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.tg-resultat.tooltip4" })
                            ])
                          ], 8, _hoisted_69)
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", {
                          class: "w-percent-md-50 not-bold result-label",
                          id: 'tco_label_tcoTotalsTotalPerYearAmount' + index
                        }, [
                          _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.resultat.label.resultat5" })
                        ], 8, _hoisted_74),
                        _createElementVNode("td", _hoisted_75, [
                          (this.initialized)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                id: 'tcoTotalsTotalPerYearAmount' + index
                              }, _toDisplayString(this.formatNumeric(p.score.tcoTotalsTotalPerYearAmount, this.currencyPerTimeUnit)), 9, _hoisted_76))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", _hoisted_77, [
                          _createElementVNode("button", {
                            class: "js-tooltip button-unstyled info-button",
                            "data-tooltip": _ctx.contentfulTcoModel.findKlarTekst('tco.tg-resultat.tooltip5'),
                            "data-tooltip-trigger": "click"
                          }, [
                            (_ctx.contentfulTcoModel.findKlarTekst('tco.tg-resultat.tooltip5') !== 'tco.tg-resultat.tooltip5')
                              ? (_openBlock(), _createElementBlock("svg", _hoisted_79, _hoisted_81))
                              : _createCommentVNode("", true),
                            _createElementVNode("span", _hoisted_82, [
                              _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.tg-resultat.tooltip5" })
                            ])
                          ], 8, _hoisted_78)
                        ])
                      ]),
                      _createElementVNode("tr", _hoisted_83, [
                        _createElementVNode("th", {
                          class: "w-percent-md-50 result-label",
                          id: 'tco_label_tcoTotalsCO2EmissionQuantity' + index
                        }, [
                          _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.resultat.label.resultat6" })
                        ], 8, _hoisted_84),
                        _createElementVNode("td", _hoisted_85, [
                          (this.initialized)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                id: 'tcoTotalsCO2EmissionQuantity' + index
                              }, _toDisplayString(this.formatNumeric(p.score.tcoTotalsCO2EmissionQuantity, this.co2Unit, true)), 9, _hoisted_86))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", _hoisted_87, [
                          _createElementVNode("button", {
                            class: "js-tooltip button-unstyled info-button",
                            "data-tooltip": _ctx.contentfulTcoModel.findKlarTekst('tco.tg-resultat.tooltip6'),
                            "data-tooltip-trigger": "click"
                          }, [
                            (_ctx.contentfulTcoModel.findKlarTekst('tco.tg-resultat.tooltip6') !== 'tco.tg-resultat.tooltip6')
                              ? (_openBlock(), _createElementBlock("svg", _hoisted_89, _hoisted_91))
                              : _createCommentVNode("", true),
                            _createElementVNode("span", _hoisted_92, [
                              _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.tg-resultat.tooltip6" })
                            ])
                          ], 8, _hoisted_88)
                        ])
                      ]),
                      _createElementVNode("tr", _hoisted_93, [
                        _createElementVNode("th", {
                          class: "w-percent-md-50 result-label",
                          id: 'tco_label_tcoTotalsTotalAmount' + index
                        }, [
                          _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.resultat.label.resultat7" })
                        ], 8, _hoisted_94),
                        _createElementVNode("td", _hoisted_95, [
                          (this.initialized)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                id: 'tcoTotalsTotalAmount' + index
                              }, _toDisplayString(this.formatNumeric(p.score.tcoTotalsTotalAmount, this.currencyUnit)), 9, _hoisted_96))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", _hoisted_97, [
                          _createElementVNode("button", {
                            class: "js-tooltip button-unstyled info-button",
                            "data-tooltip": _ctx.contentfulTcoModel.findKlarTekst('tco.tg-resultat.tooltip7'),
                            "data-tooltip-trigger": "click"
                          }, [
                            (_ctx.contentfulTcoModel.findKlarTekst('tco.tg-resultat.tooltip7') !== 'tco.tg-resultat.tooltip7')
                              ? (_openBlock(), _createElementBlock("svg", _hoisted_99, _hoisted_101))
                              : _createCommentVNode("", true),
                            _createElementVNode("span", _hoisted_102, [
                              _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.tg-resultat.tooltip7" })
                            ])
                          ], 8, _hoisted_98)
                        ])
                      ])
                    ])
                  ])
                ], 4),
                (this.initialized)
                  ? (_openBlock(), _createBlock(_component_CO2ComparisonChart, {
                      key: 1,
                      chartData: _ctx.co2Data[index],
                      chartTitle: _ctx.contentfulTcoModel.findKlarTekst('tco.resultat.label.graph0'),
                      id: 'co2-chart-' + index,
                      printMode: this.printMode
                    }, null, 8, ["chartData", "chartTitle", "id", "printMode"]))
                  : _createCommentVNode("", true),
                (this.initialized)
                  ? (_openBlock(), _createBlock(_component_TCOScoreProductComparisonChart, {
                      key: 2,
                      chartData: _ctx.dataCollection[index],
                      chartTitle: _ctx.contentfulTcoModel.findKlarTekst('tco.resultat.label.graph1'),
                      id: 'tco-chart-' + index,
                      printMode: this.printMode
                    }, null, 8, ["chartData", "chartTitle", "id", "printMode"]))
                  : _createCommentVNode("", true)
              ], 2)
            ], 8, _hoisted_15)
          ], 8, _hoisted_13)
        ])
      ], 2))
    }), 128))
  ]))
}